export const TIER_NAMES = {
  1: 'Rookie',
  2: 'Starter',
  3: 'Veteran',
  4: 'All-Star',
  5: 'Hall of Fame',
} as const;

export const TIER_STYLES = {
  1: {
    chip: 'bg-white text-[#736758] border border-[#D4C5A9]',
    icon: 'bg-[#736758] text-white',
    name: 'text-[#736758]',
  },
  2: {
    chip: 'bg-white text-[#5C4A32] border border-[#5C4A32]',
    icon: 'bg-[#5C4A32] text-[#F5F0E8]',
    name: 'text-[#5C4A32]',
  },
  3: {
    chip: 'bg-[#2C2416] text-[#F5F0E8] border border-[#2C2416]',
    icon: 'bg-[#F5F0E8] text-[#2C2416]',
    name: 'text-[#2C2416]',
  },
  4: {
    chip: 'bg-gradient-to-br from-[#B8860B] via-[#D4A017] to-[#B8860B] text-[#2C2416] border border-[#8B6914]',
    icon: 'bg-[#2C2416] text-[#B8860B]',
    name: 'text-[#8B6914]',
  },
  5: {
    chip: 'bg-[#2C2416] text-[#B8860B] border-[1.5px] border-[#B8860B]',
    icon: 'bg-[#B8860B] text-[#2C2416]',
    name: 'text-[#B8860B]',
  },
} as const;

export const TIER_TOOLTIP_COLORS = {
  1: '#736758',
  2: '#5C4A32',
  3: '#F5F0E8',
  4: '#B8860B',
  5: '#B8860B',
} as const;

export const CATEGORY_ORDER = [
  'volume',
  'streaks',
  'craft',
  'coverage',
  'special_moments',
  'community',
  'social_sharing',
  'calendar',
  'prestige',
] as const;

export const CATEGORY_LABELS: Record<string, string> = {
  volume: 'Volume & Consistency',
  streaks: 'Streaks',
  craft: 'Craft & Artistry',
  coverage: 'Coverage & Breadth',
  special_moments: 'Special Moments',
  community: 'Community & Engagement',
  social_sharing: 'Social Sharing',
  calendar: 'Calendar & Timing',
  prestige: 'Prestige',
};

export const CATEGORY_PRIORITY: Record<string, number> = {
  prestige: 9,
  special_moments: 8,
  coverage: 7,
  craft: 6,
  calendar: 5,
  streaks: 4,
  community: 3,
  social_sharing: 2,
  volume: 1,
};
